import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
  width: 100%;

  @media (min-width: 960px) {
    flex-direction: row;
    align-items: stretch;
    gap: 16px;
    min-height: calc(100vh - 200px);
    max-height: calc(100vh - 120px);
  }
`;

export const LeftColumnPane = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;

  @media (min-width: 960px) {
    flex: 1 1 42%;
    max-width: 50%;
    min-height: 0;
    max-height: calc(100vh - 200px);
  }
`;

export const RightColumnPane = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;

  @media (min-width: 960px) {
    flex: 1 1 58%;
    min-height: 0;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 4px;
  }
`;

export const TableScrollBox = styled.div`
  flex: 1;
  min-height: 200px;
  overflow: auto;
  border-radius: 4px;
  border: 1px solid #000;
  background: #1a1d24;

  @media (min-width: 960px) {
    min-height: 0;
    max-height: 100%;
  }
`;

export const FiltersRow = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;

  > * {
    width: 100%;
    max-width: 1100px;
  }

  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker__input-container input {
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
`;

export const TableSection = styled.div`
  margin-top: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 8px;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const ChartPanel = styled.div`
  margin-top: 0;
  padding: 12px;
  min-height: 240px;
  background: #1e2127;
  border: 1px solid #000;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (min-width: 960px) {
    min-height: 260px;
    padding: 16px;
  }
`;

export const ChartTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-align: center;
`;

/** Só a tabela de detalhes (agente, assistência, distrito, descrição) no proximity-dash. */
export const ProximityDetailTableWrap = styled.div`
  font-size: 11px;
  line-height: 1.35;

  table th,
  table td {
    font-size: 11px;
    padding: 0.35rem 0.45rem;
  }
`;

export const ChartsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  height: 100%;

  @media (min-width: 960px) {
    gap: 16px;
  }
`;

/** Pizza + resumo por tipo na mesma linha (desktop); empilhados no mobile. */
export const PieSummaryRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  width: 100%;

  @media (min-width: 960px) {
    flex-direction: row;
    align-items: stretch;
    gap: 16px;
  }

  > *:first-child {
    flex: 1 1 58%;
    min-width: 0;
  }

  > *:last-child {
    flex: 1 1 42%;
    min-width: 0;
    justify-content: center;
  }
`;

export const BarChartPanel = styled.div`
  padding: 16px;
  background: #1e2127;
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 160px;
  width: 100%;
`;

export const SummaryPanel = styled.div`
  margin-top: 0;
  padding: 16px;
  min-height: auto;
  background: #1e2127;
  border: 1px solid #000;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  line-height: 1.35;

  ${ChartTitle} {
    font-size: 12px;
    margin-bottom: 6px;
  }

  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid black;

    tr:last-child td {
      border-bottom: 0;
    }

    th {
      margin: 0;
      padding: 0.35rem 0.45rem;
      border-bottom: 1px solid black;
      background: black;
      color: white;
      font-weight: bold;
      font-size: 11px;
    }

    td {
      margin: 0;
      padding: 0.35rem 0.45rem;
      border-bottom: 1px solid black;
      background-color: #2c2f38;
      color: white;
      font-weight: 500;
      text-align: center;
      font-size: 11px;
    }

    tbody tr:last-child td {
      background-color: #3d4450;
      font-weight: 700;
    }
  }
`;
